import {
  login as defaultLogin,
  logout as defaultLogout,
  currentSession,
} from '../amplifyHandlers';

const defaultGetPermissions = async () => {
  const permissions = localStorage.getItem('permissions');
  if (permissions) {
    return JSON.parse(permissions);
  }

  return [];
};

const defaultCheckError = error => {
  const { status } = error;
  if (status === 401 || status === 403) {
    localStorage.removeItem('permissions');
    return Promise.reject();
  }

  return Promise.resolve();
};

const buildAuthProvider = ({
  login = defaultLogin,
  logout = defaultLogout,
  checkAuth = currentSession,
  checkError = defaultCheckError,
  getPermissions = defaultGetPermissions,
} = {}) => {
  return {
    login: params => login(params),
    logout: () => logout(),
    checkAuth: params => checkAuth(params),
    checkError: error => checkError(error),
    getPermissions: params => getPermissions(params),
  };
};

export default buildAuthProvider;
